import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'public',
  templateUrl: 'publicLayout.template.html',
  styleUrls: ['./publicLayout.component.scss']
})
export class PublicLayoutComponent {

  public isNavigationOpen = false;
  public isWatchView = false; // Track if current route is a watch publication

  constructor(
    public app: ApplicationConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    // Listen to route changes to detect watch publication routes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute.firstChild;
        while (route?.firstChild) {
          route = route.firstChild;
        }
        return route?.snapshot.data || {};
      })
    ).subscribe(data => {
      // Check if this is a watch publication route (fire-foresight-watch or camera-watch)
      this.isWatchView = this.router.url.includes('/publication/fire-foresight-watch/') || 
                         this.router.url.includes('/publication/camera-watch/');
    });
  }
  

  ngOnInit() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-small');
    this.onNavigationToggle(this.isNavigationOpen);
    
    // Check initial route
    this.isWatchView = this.router.url.includes('/publication/fire-foresight-watch/') || 
                       this.router.url.includes('/publication/camera-watch/');
  }

  onResize() {
  }

  onNavigationToggle(bool: boolean): void {
    const body = document.getElementsByTagName('body')[0];
    if (bool) {
      body.classList.add('mini-navbar');
    } else {
      body.classList.remove('mini-navbar');
    }
  }
}
